import React from "react";
import Select from "react-select";

import { useSidebarLayoutContext } from "contexts/SidebarLayoutContext";

const ReactSelect = (props) => {
  const { darkMode } = useSidebarLayoutContext();

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: darkMode ? "#2D3748" : "#EDF2F7",
      color: darkMode ? "#A0AEC0" : "#1A202C",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? darkMode
          ? "#4A5568"
          : "#4299E1"
        : state.isFocused
        ? darkMode
          ? "#2D3748"
          : "#63B3ED"
        : null,
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: darkMode ? "#A0AEC0" : "#1A202C",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 9999,
      backgroundColor: darkMode ? "#4A5568" : "#EDF2F7",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  return (
    <Select menuPortalTarget={document.body} styles={customStyles} {...props} />
  );
};

export default ReactSelect;
